// @generated by protobuf-ts 2.11.1 with parameter output_javascript
// @generated from protobuf file "servicechannel.proto" (syntax proto3)
// tslint:disable
// @generated by protobuf-ts 2.11.1 with parameter output_javascript
// @generated from protobuf file "servicechannel.proto" (syntax proto3)
// tslint:disable
import { Empty } from "./common";
import { Bool } from "./common";
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { WireType } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
// @generated message type with reflection information, may provide speed optimized methods
class SCGetAuthURLRequest$Type extends MessageType {
    constructor() {
        super("SCGetAuthURLRequest", [
            { no: 1, name: "state", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "redirect_uri", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.state = "";
        message.redirectUri = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string state */ 1:
                    message.state = reader.string();
                    break;
                case /* string redirect_uri */ 2:
                    message.redirectUri = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string state = 1; */
        if (message.state !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.state);
        /* string redirect_uri = 2; */
        if (message.redirectUri !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.redirectUri);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SCGetAuthURLRequest
 */
export const SCGetAuthURLRequest = new SCGetAuthURLRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SCGetAuthURLResponse$Type extends MessageType {
    constructor() {
        super("SCGetAuthURLResponse", [
            { no: 1, name: "url", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.url = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string url */ 1:
                    message.url = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string url = 1; */
        if (message.url !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.url);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SCGetAuthURLResponse
 */
export const SCGetAuthURLResponse = new SCGetAuthURLResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SCExchangeCodeRequest$Type extends MessageType {
    constructor() {
        super("SCExchangeCodeRequest", [
            { no: 1, name: "code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "redirect_uri", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.code = "";
        message.redirectUri = "";
        message.userId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string code */ 1:
                    message.code = reader.string();
                    break;
                case /* string redirect_uri */ 2:
                    message.redirectUri = reader.string();
                    break;
                case /* int32 user_id */ 3:
                    message.userId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string code = 1; */
        if (message.code !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.code);
        /* string redirect_uri = 2; */
        if (message.redirectUri !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.redirectUri);
        /* int32 user_id = 3; */
        if (message.userId !== 0)
            writer.tag(3, WireType.Varint).int32(message.userId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SCExchangeCodeRequest
 */
export const SCExchangeCodeRequest = new SCExchangeCodeRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SCRefreshTokenRequest$Type extends MessageType {
    constructor() {
        super("SCRefreshTokenRequest", [
            { no: 1, name: "refresh_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.refreshToken = "";
        message.userId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string refresh_token */ 1:
                    message.refreshToken = reader.string();
                    break;
                case /* int32 user_id */ 2:
                    message.userId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string refresh_token = 1; */
        if (message.refreshToken !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.refreshToken);
        /* int32 user_id = 2; */
        if (message.userId !== 0)
            writer.tag(2, WireType.Varint).int32(message.userId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SCRefreshTokenRequest
 */
export const SCRefreshTokenRequest = new SCRefreshTokenRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SCChecklistRequest$Type extends MessageType {
    constructor() {
        super("SCChecklistRequest", [
            { no: 1, name: "event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.eventId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 event_id */ 1:
                    message.eventId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 event_id = 1; */
        if (message.eventId !== 0)
            writer.tag(1, WireType.Varint).int32(message.eventId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SCChecklistRequest
 */
export const SCChecklistRequest = new SCChecklistRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SCChecklistQuestionOption$Type extends MessageType {
    constructor() {
        super("SCChecklistQuestionOption", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "answer", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "sequence", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "response_result_in_failure", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.answer = "";
        message.sequence = 0;
        message.responseResultInFailure = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* string answer */ 2:
                    message.answer = reader.string();
                    break;
                case /* int32 sequence */ 3:
                    message.sequence = reader.int32();
                    break;
                case /* bool response_result_in_failure */ 4:
                    message.responseResultInFailure = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* string answer = 2; */
        if (message.answer !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.answer);
        /* int32 sequence = 3; */
        if (message.sequence !== 0)
            writer.tag(3, WireType.Varint).int32(message.sequence);
        /* bool response_result_in_failure = 4; */
        if (message.responseResultInFailure !== false)
            writer.tag(4, WireType.Varint).bool(message.responseResultInFailure);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SCChecklistQuestionOption
 */
export const SCChecklistQuestionOption = new SCChecklistQuestionOption$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SCChecklistQuestion$Type extends MessageType {
    constructor() {
        super("SCChecklistQuestion", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "question", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "question_type", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "answer_required", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "allow_multi_select", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "sequence", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "options", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SCChecklistQuestionOption },
            { no: 8, name: "selected_option_ids", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "free_text_answer", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.question = "";
        message.questionType = 0;
        message.answerRequired = false;
        message.allowMultiSelect = false;
        message.sequence = 0;
        message.options = [];
        message.selectedOptionIds = [];
        message.freeTextAnswer = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* string question */ 2:
                    message.question = reader.string();
                    break;
                case /* int32 question_type */ 3:
                    message.questionType = reader.int32();
                    break;
                case /* bool answer_required */ 4:
                    message.answerRequired = reader.bool();
                    break;
                case /* bool allow_multi_select */ 5:
                    message.allowMultiSelect = reader.bool();
                    break;
                case /* int32 sequence */ 6:
                    message.sequence = reader.int32();
                    break;
                case /* repeated SCChecklistQuestionOption options */ 7:
                    message.options.push(SCChecklistQuestionOption.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated int32 selected_option_ids */ 8:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.selectedOptionIds.push(reader.int32());
                    else
                        message.selectedOptionIds.push(reader.int32());
                    break;
                case /* string free_text_answer */ 9:
                    message.freeTextAnswer = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* string question = 2; */
        if (message.question !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.question);
        /* int32 question_type = 3; */
        if (message.questionType !== 0)
            writer.tag(3, WireType.Varint).int32(message.questionType);
        /* bool answer_required = 4; */
        if (message.answerRequired !== false)
            writer.tag(4, WireType.Varint).bool(message.answerRequired);
        /* bool allow_multi_select = 5; */
        if (message.allowMultiSelect !== false)
            writer.tag(5, WireType.Varint).bool(message.allowMultiSelect);
        /* int32 sequence = 6; */
        if (message.sequence !== 0)
            writer.tag(6, WireType.Varint).int32(message.sequence);
        /* repeated SCChecklistQuestionOption options = 7; */
        for (let i = 0; i < message.options.length; i++)
            SCChecklistQuestionOption.internalBinaryWrite(message.options[i], writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* repeated int32 selected_option_ids = 8; */
        if (message.selectedOptionIds.length) {
            writer.tag(8, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.selectedOptionIds.length; i++)
                writer.int32(message.selectedOptionIds[i]);
            writer.join();
        }
        /* string free_text_answer = 9; */
        if (message.freeTextAnswer !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.freeTextAnswer);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SCChecklistQuestion
 */
export const SCChecklistQuestion = new SCChecklistQuestion$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SCChecklist$Type extends MessageType {
    constructor() {
        super("SCChecklist", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "display_for_each_asset", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "questions", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SCChecklistQuestion }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.name = "";
        message.displayForEachAsset = false;
        message.questions = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* bool display_for_each_asset */ 3:
                    message.displayForEachAsset = reader.bool();
                    break;
                case /* repeated SCChecklistQuestion questions */ 4:
                    message.questions.push(SCChecklistQuestion.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* bool display_for_each_asset = 3; */
        if (message.displayForEachAsset !== false)
            writer.tag(3, WireType.Varint).bool(message.displayForEachAsset);
        /* repeated SCChecklistQuestion questions = 4; */
        for (let i = 0; i < message.questions.length; i++)
            SCChecklistQuestion.internalBinaryWrite(message.questions[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SCChecklist
 */
export const SCChecklist = new SCChecklist$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SCChecklistResponse$Type extends MessageType {
    constructor() {
        super("SCChecklistResponse", [
            { no: 1, name: "checklists", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SCChecklist }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.checklists = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated SCChecklist checklists */ 1:
                    message.checklists.push(SCChecklist.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated SCChecklist checklists = 1; */
        for (let i = 0; i < message.checklists.length; i++)
            SCChecklist.internalBinaryWrite(message.checklists[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SCChecklistResponse
 */
export const SCChecklistResponse = new SCChecklistResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SCChecklistAnswer$Type extends MessageType {
    constructor() {
        super("SCChecklistAnswer", [
            { no: 1, name: "question_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "option_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "free_text_answer", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.questionId = 0;
        message.optionId = 0;
        message.freeTextAnswer = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 question_id */ 1:
                    message.questionId = reader.int32();
                    break;
                case /* int32 option_id */ 2:
                    message.optionId = reader.int32();
                    break;
                case /* string free_text_answer */ 3:
                    message.freeTextAnswer = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 question_id = 1; */
        if (message.questionId !== 0)
            writer.tag(1, WireType.Varint).int32(message.questionId);
        /* int32 option_id = 2; */
        if (message.optionId !== 0)
            writer.tag(2, WireType.Varint).int32(message.optionId);
        /* string free_text_answer = 3; */
        if (message.freeTextAnswer !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.freeTextAnswer);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SCChecklistAnswer
 */
export const SCChecklistAnswer = new SCChecklistAnswer$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SCSaveChecklistAnswersRequest$Type extends MessageType {
    constructor() {
        super("SCSaveChecklistAnswersRequest", [
            { no: 1, name: "event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "checklist_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "answers", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SCChecklistAnswer },
            { no: 4, name: "answered_by_user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.eventId = 0;
        message.checklistId = 0;
        message.answers = [];
        message.answeredByUserId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 event_id */ 1:
                    message.eventId = reader.int32();
                    break;
                case /* int32 checklist_id */ 2:
                    message.checklistId = reader.int32();
                    break;
                case /* repeated SCChecklistAnswer answers */ 3:
                    message.answers.push(SCChecklistAnswer.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 answered_by_user_id */ 4:
                    message.answeredByUserId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 event_id = 1; */
        if (message.eventId !== 0)
            writer.tag(1, WireType.Varint).int32(message.eventId);
        /* int32 checklist_id = 2; */
        if (message.checklistId !== 0)
            writer.tag(2, WireType.Varint).int32(message.checklistId);
        /* repeated SCChecklistAnswer answers = 3; */
        for (let i = 0; i < message.answers.length; i++)
            SCChecklistAnswer.internalBinaryWrite(message.answers[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* int32 answered_by_user_id = 4; */
        if (message.answeredByUserId !== 0)
            writer.tag(4, WireType.Varint).int32(message.answeredByUserId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SCSaveChecklistAnswersRequest
 */
export const SCSaveChecklistAnswersRequest = new SCSaveChecklistAnswersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SCLinkRequest$Type extends MessageType {
    constructor() {
        super("SCLinkRequest", [
            { no: 1, name: "event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.eventId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 event_id */ 1:
                    message.eventId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 event_id = 1; */
        if (message.eventId !== 0)
            writer.tag(1, WireType.Varint).int32(message.eventId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SCLinkRequest
 */
export const SCLinkRequest = new SCLinkRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SCSyncLogEntry$Type extends MessageType {
    constructor() {
        super("SCSyncLogEntry", [
            { no: 1, name: "id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "direction", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "event_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "sc_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 5, name: "status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "display_status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "error", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "created_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "processed_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "attempts", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 11, name: "retryable", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0n;
        message.direction = "";
        message.eventType = "";
        message.scId = 0n;
        message.status = "";
        message.displayStatus = "";
        message.error = "";
        message.createdAt = "";
        message.processedAt = "";
        message.attempts = 0;
        message.retryable = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 id */ 1:
                    message.id = reader.int64().toBigInt();
                    break;
                case /* string direction */ 2:
                    message.direction = reader.string();
                    break;
                case /* string event_type */ 3:
                    message.eventType = reader.string();
                    break;
                case /* int64 sc_id */ 4:
                    message.scId = reader.int64().toBigInt();
                    break;
                case /* string status */ 5:
                    message.status = reader.string();
                    break;
                case /* string display_status */ 6:
                    message.displayStatus = reader.string();
                    break;
                case /* string error */ 7:
                    message.error = reader.string();
                    break;
                case /* string created_at */ 8:
                    message.createdAt = reader.string();
                    break;
                case /* string processed_at */ 9:
                    message.processedAt = reader.string();
                    break;
                case /* int32 attempts */ 10:
                    message.attempts = reader.int32();
                    break;
                case /* bool retryable */ 11:
                    message.retryable = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 id = 1; */
        if (message.id !== 0n)
            writer.tag(1, WireType.Varint).int64(message.id);
        /* string direction = 2; */
        if (message.direction !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.direction);
        /* string event_type = 3; */
        if (message.eventType !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.eventType);
        /* int64 sc_id = 4; */
        if (message.scId !== 0n)
            writer.tag(4, WireType.Varint).int64(message.scId);
        /* string status = 5; */
        if (message.status !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.status);
        /* string display_status = 6; */
        if (message.displayStatus !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.displayStatus);
        /* string error = 7; */
        if (message.error !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.error);
        /* string created_at = 8; */
        if (message.createdAt !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.createdAt);
        /* string processed_at = 9; */
        if (message.processedAt !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.processedAt);
        /* int32 attempts = 10; */
        if (message.attempts !== 0)
            writer.tag(10, WireType.Varint).int32(message.attempts);
        /* bool retryable = 11; */
        if (message.retryable !== false)
            writer.tag(11, WireType.Varint).bool(message.retryable);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SCSyncLogEntry
 */
export const SCSyncLogEntry = new SCSyncLogEntry$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SCLinkResponse$Type extends MessageType {
    constructor() {
        super("SCLinkResponse", [
            { no: 1, name: "linked", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "subscriber_enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "sc_wo_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 4, name: "sc_wo_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "sc_subscriber_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 6, name: "customer_user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "nte", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "sc_status_primary", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "sc_status_extended", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 16, name: "sc_status_received_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "sc_proposal_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 11, name: "sc_invoice_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 12, name: "sc_invoice_status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "sync_log", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SCSyncLogEntry },
            { no: 14, name: "arrival", kind: "message", T: () => SCVisitOutcome },
            { no: 15, name: "proposals", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SCProposal },
            { no: 17, name: "checkout", kind: "message", T: () => SCVisitOutcome },
            { no: 18, name: "completion_hold_sr_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 19, name: "completion_held_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.linked = false;
        message.subscriberEnabled = false;
        message.scWoId = 0n;
        message.scWoNumber = "";
        message.scSubscriberId = 0n;
        message.customerUserId = 0;
        message.nte = "";
        message.scStatusPrimary = "";
        message.scStatusExtended = "";
        message.scStatusReceivedAt = "";
        message.scProposalId = 0n;
        message.scInvoiceId = 0n;
        message.scInvoiceStatus = "";
        message.syncLog = [];
        message.proposals = [];
        message.completionHoldSrId = 0;
        message.completionHeldAt = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool linked */ 1:
                    message.linked = reader.bool();
                    break;
                case /* bool subscriber_enabled */ 2:
                    message.subscriberEnabled = reader.bool();
                    break;
                case /* int64 sc_wo_id */ 3:
                    message.scWoId = reader.int64().toBigInt();
                    break;
                case /* string sc_wo_number */ 4:
                    message.scWoNumber = reader.string();
                    break;
                case /* int64 sc_subscriber_id */ 5:
                    message.scSubscriberId = reader.int64().toBigInt();
                    break;
                case /* int32 customer_user_id */ 6:
                    message.customerUserId = reader.int32();
                    break;
                case /* string nte */ 7:
                    message.nte = reader.string();
                    break;
                case /* string sc_status_primary */ 8:
                    message.scStatusPrimary = reader.string();
                    break;
                case /* string sc_status_extended */ 9:
                    message.scStatusExtended = reader.string();
                    break;
                case /* string sc_status_received_at */ 16:
                    message.scStatusReceivedAt = reader.string();
                    break;
                case /* int64 sc_proposal_id */ 10:
                    message.scProposalId = reader.int64().toBigInt();
                    break;
                case /* int64 sc_invoice_id */ 11:
                    message.scInvoiceId = reader.int64().toBigInt();
                    break;
                case /* string sc_invoice_status */ 12:
                    message.scInvoiceStatus = reader.string();
                    break;
                case /* repeated SCSyncLogEntry sync_log */ 13:
                    message.syncLog.push(SCSyncLogEntry.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* SCVisitOutcome arrival */ 14:
                    message.arrival = SCVisitOutcome.internalBinaryRead(reader, reader.uint32(), options, message.arrival);
                    break;
                case /* repeated SCProposal proposals */ 15:
                    message.proposals.push(SCProposal.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* SCVisitOutcome checkout */ 17:
                    message.checkout = SCVisitOutcome.internalBinaryRead(reader, reader.uint32(), options, message.checkout);
                    break;
                case /* int32 completion_hold_sr_id */ 18:
                    message.completionHoldSrId = reader.int32();
                    break;
                case /* string completion_held_at */ 19:
                    message.completionHeldAt = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool linked = 1; */
        if (message.linked !== false)
            writer.tag(1, WireType.Varint).bool(message.linked);
        /* bool subscriber_enabled = 2; */
        if (message.subscriberEnabled !== false)
            writer.tag(2, WireType.Varint).bool(message.subscriberEnabled);
        /* int64 sc_wo_id = 3; */
        if (message.scWoId !== 0n)
            writer.tag(3, WireType.Varint).int64(message.scWoId);
        /* string sc_wo_number = 4; */
        if (message.scWoNumber !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.scWoNumber);
        /* int64 sc_subscriber_id = 5; */
        if (message.scSubscriberId !== 0n)
            writer.tag(5, WireType.Varint).int64(message.scSubscriberId);
        /* int32 customer_user_id = 6; */
        if (message.customerUserId !== 0)
            writer.tag(6, WireType.Varint).int32(message.customerUserId);
        /* string nte = 7; */
        if (message.nte !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.nte);
        /* string sc_status_primary = 8; */
        if (message.scStatusPrimary !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.scStatusPrimary);
        /* string sc_status_extended = 9; */
        if (message.scStatusExtended !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.scStatusExtended);
        /* int64 sc_proposal_id = 10; */
        if (message.scProposalId !== 0n)
            writer.tag(10, WireType.Varint).int64(message.scProposalId);
        /* int64 sc_invoice_id = 11; */
        if (message.scInvoiceId !== 0n)
            writer.tag(11, WireType.Varint).int64(message.scInvoiceId);
        /* string sc_invoice_status = 12; */
        if (message.scInvoiceStatus !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.scInvoiceStatus);
        /* repeated SCSyncLogEntry sync_log = 13; */
        for (let i = 0; i < message.syncLog.length; i++)
            SCSyncLogEntry.internalBinaryWrite(message.syncLog[i], writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* SCVisitOutcome arrival = 14; */
        if (message.arrival)
            SCVisitOutcome.internalBinaryWrite(message.arrival, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* repeated SCProposal proposals = 15; */
        for (let i = 0; i < message.proposals.length; i++)
            SCProposal.internalBinaryWrite(message.proposals[i], writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* string sc_status_received_at = 16; */
        if (message.scStatusReceivedAt !== "")
            writer.tag(16, WireType.LengthDelimited).string(message.scStatusReceivedAt);
        /* SCVisitOutcome checkout = 17; */
        if (message.checkout)
            SCVisitOutcome.internalBinaryWrite(message.checkout, writer.tag(17, WireType.LengthDelimited).fork(), options).join();
        /* int32 completion_hold_sr_id = 18; */
        if (message.completionHoldSrId !== 0)
            writer.tag(18, WireType.Varint).int32(message.completionHoldSrId);
        /* string completion_held_at = 19; */
        if (message.completionHeldAt !== "")
            writer.tag(19, WireType.LengthDelimited).string(message.completionHeldAt);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SCLinkResponse
 */
export const SCLinkResponse = new SCLinkResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SCProposal$Type extends MessageType {
    constructor() {
        super("SCProposal", [
            { no: 1, name: "sc_proposal_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "quote_document_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "proposal_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "decision", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "decided_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "created_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.scProposalId = 0n;
        message.quoteDocumentId = 0;
        message.proposalNumber = "";
        message.decision = "";
        message.decidedAt = "";
        message.createdAt = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 sc_proposal_id */ 1:
                    message.scProposalId = reader.int64().toBigInt();
                    break;
                case /* int32 quote_document_id */ 2:
                    message.quoteDocumentId = reader.int32();
                    break;
                case /* string proposal_number */ 3:
                    message.proposalNumber = reader.string();
                    break;
                case /* string decision */ 4:
                    message.decision = reader.string();
                    break;
                case /* string decided_at */ 5:
                    message.decidedAt = reader.string();
                    break;
                case /* string created_at */ 6:
                    message.createdAt = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 sc_proposal_id = 1; */
        if (message.scProposalId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.scProposalId);
        /* int32 quote_document_id = 2; */
        if (message.quoteDocumentId !== 0)
            writer.tag(2, WireType.Varint).int32(message.quoteDocumentId);
        /* string proposal_number = 3; */
        if (message.proposalNumber !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.proposalNumber);
        /* string decision = 4; */
        if (message.decision !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.decision);
        /* string decided_at = 5; */
        if (message.decidedAt !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.decidedAt);
        /* string created_at = 6; */
        if (message.createdAt !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.createdAt);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SCProposal
 */
export const SCProposal = new SCProposal$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SCVisitRequest$Type extends MessageType {
    constructor() {
        super("SCVisitRequest", [
            { no: 1, name: "event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "services_rendered_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.eventId = 0;
        message.servicesRenderedId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 event_id */ 1:
                    message.eventId = reader.int32();
                    break;
                case /* int32 services_rendered_id */ 2:
                    message.servicesRenderedId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 event_id = 1; */
        if (message.eventId !== 0)
            writer.tag(1, WireType.Varint).int32(message.eventId);
        /* int32 services_rendered_id = 2; */
        if (message.servicesRenderedId !== 0)
            writer.tag(2, WireType.Varint).int32(message.servicesRenderedId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SCVisitRequest
 */
export const SCVisitRequest = new SCVisitRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SCVisitOutcome$Type extends MessageType {
    constructor() {
        super("SCVisitOutcome", [
            { no: 1, name: "state", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "refusal_kind", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "sc_error_code", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "distance_miles", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "max_radius_miles", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "occurred_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "tech_user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "services_rendered_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "sync_event_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 10, name: "attempts", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 11, name: "detail", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "retryable", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 13, name: "sc_error_message", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "status_delivered", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 15, name: "visit_kind", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.state = "";
        message.refusalKind = "";
        message.scErrorCode = 0;
        message.distanceMiles = 0;
        message.maxRadiusMiles = 0;
        message.occurredAt = "";
        message.techUserId = 0;
        message.servicesRenderedId = 0;
        message.syncEventId = 0n;
        message.attempts = 0;
        message.detail = "";
        message.retryable = false;
        message.scErrorMessage = "";
        message.statusDelivered = false;
        message.visitKind = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string state */ 1:
                    message.state = reader.string();
                    break;
                case /* string refusal_kind */ 2:
                    message.refusalKind = reader.string();
                    break;
                case /* int32 sc_error_code */ 3:
                    message.scErrorCode = reader.int32();
                    break;
                case /* double distance_miles */ 4:
                    message.distanceMiles = reader.double();
                    break;
                case /* double max_radius_miles */ 5:
                    message.maxRadiusMiles = reader.double();
                    break;
                case /* string occurred_at */ 6:
                    message.occurredAt = reader.string();
                    break;
                case /* int32 tech_user_id */ 7:
                    message.techUserId = reader.int32();
                    break;
                case /* int32 services_rendered_id */ 8:
                    message.servicesRenderedId = reader.int32();
                    break;
                case /* int64 sync_event_id */ 9:
                    message.syncEventId = reader.int64().toBigInt();
                    break;
                case /* int32 attempts */ 10:
                    message.attempts = reader.int32();
                    break;
                case /* string detail */ 11:
                    message.detail = reader.string();
                    break;
                case /* bool retryable */ 12:
                    message.retryable = reader.bool();
                    break;
                case /* string sc_error_message */ 13:
                    message.scErrorMessage = reader.string();
                    break;
                case /* bool status_delivered */ 14:
                    message.statusDelivered = reader.bool();
                    break;
                case /* string visit_kind */ 15:
                    message.visitKind = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string state = 1; */
        if (message.state !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.state);
        /* string refusal_kind = 2; */
        if (message.refusalKind !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.refusalKind);
        /* int32 sc_error_code = 3; */
        if (message.scErrorCode !== 0)
            writer.tag(3, WireType.Varint).int32(message.scErrorCode);
        /* double distance_miles = 4; */
        if (message.distanceMiles !== 0)
            writer.tag(4, WireType.Bit64).double(message.distanceMiles);
        /* double max_radius_miles = 5; */
        if (message.maxRadiusMiles !== 0)
            writer.tag(5, WireType.Bit64).double(message.maxRadiusMiles);
        /* string occurred_at = 6; */
        if (message.occurredAt !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.occurredAt);
        /* int32 tech_user_id = 7; */
        if (message.techUserId !== 0)
            writer.tag(7, WireType.Varint).int32(message.techUserId);
        /* int32 services_rendered_id = 8; */
        if (message.servicesRenderedId !== 0)
            writer.tag(8, WireType.Varint).int32(message.servicesRenderedId);
        /* int64 sync_event_id = 9; */
        if (message.syncEventId !== 0n)
            writer.tag(9, WireType.Varint).int64(message.syncEventId);
        /* int32 attempts = 10; */
        if (message.attempts !== 0)
            writer.tag(10, WireType.Varint).int32(message.attempts);
        /* string detail = 11; */
        if (message.detail !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.detail);
        /* bool retryable = 12; */
        if (message.retryable !== false)
            writer.tag(12, WireType.Varint).bool(message.retryable);
        /* string sc_error_message = 13; */
        if (message.scErrorMessage !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.scErrorMessage);
        /* bool status_delivered = 14; */
        if (message.statusDelivered !== false)
            writer.tag(14, WireType.Varint).bool(message.statusDelivered);
        /* string visit_kind = 15; */
        if (message.visitKind !== "")
            writer.tag(15, WireType.LengthDelimited).string(message.visitKind);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SCVisitOutcome
 */
export const SCVisitOutcome = new SCVisitOutcome$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SCBadgeRequest$Type extends MessageType {
    constructor() {
        super("SCBadgeRequest", [
            { no: 1, name: "event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "property_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.eventId = 0;
        message.propertyId = 0;
        message.userId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 event_id */ 1:
                    message.eventId = reader.int32();
                    break;
                case /* int32 property_id */ 2:
                    message.propertyId = reader.int32();
                    break;
                case /* int32 user_id */ 3:
                    message.userId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 event_id = 1; */
        if (message.eventId !== 0)
            writer.tag(1, WireType.Varint).int32(message.eventId);
        /* int32 property_id = 2; */
        if (message.propertyId !== 0)
            writer.tag(2, WireType.Varint).int32(message.propertyId);
        /* int32 user_id = 3; */
        if (message.userId !== 0)
            writer.tag(3, WireType.Varint).int32(message.userId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SCBadgeRequest
 */
export const SCBadgeRequest = new SCBadgeRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SCBadgeResponse$Type extends MessageType {
    constructor() {
        super("SCBadgeResponse", [
            { no: 1, name: "linked", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "level", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "sc_subscriber_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.linked = false;
        message.level = "";
        message.scSubscriberId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool linked */ 1:
                    message.linked = reader.bool();
                    break;
                case /* string level */ 2:
                    message.level = reader.string();
                    break;
                case /* int64 sc_subscriber_id */ 3:
                    message.scSubscriberId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool linked = 1; */
        if (message.linked !== false)
            writer.tag(1, WireType.Varint).bool(message.linked);
        /* string level = 2; */
        if (message.level !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.level);
        /* int64 sc_subscriber_id = 3; */
        if (message.scSubscriberId !== 0n)
            writer.tag(3, WireType.Varint).int64(message.scSubscriberId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SCBadgeResponse
 */
export const SCBadgeResponse = new SCBadgeResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SCSubmitProposalRequest$Type extends MessageType {
    constructor() {
        super("SCSubmitProposalRequest", [
            { no: 1, name: "quote_document_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.quoteDocumentId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 quote_document_id */ 1:
                    message.quoteDocumentId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 quote_document_id = 1; */
        if (message.quoteDocumentId !== 0)
            writer.tag(1, WireType.Varint).int32(message.quoteDocumentId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SCSubmitProposalRequest
 */
export const SCSubmitProposalRequest = new SCSubmitProposalRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SCRetrySyncEventRequest$Type extends MessageType {
    constructor() {
        super("SCRetrySyncEventRequest", [
            { no: 1, name: "sync_event_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.syncEventId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 sync_event_id */ 1:
                    message.syncEventId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 sync_event_id = 1; */
        if (message.syncEventId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.syncEventId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SCRetrySyncEventRequest
 */
export const SCRetrySyncEventRequest = new SCRetrySyncEventRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SCSubscriberSummary$Type extends MessageType {
    constructor() {
        super("SCSubscriberSummary", [
            { no: 1, name: "subscriber_config_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "sc_subscriber_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "customer_user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "customer_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.subscriberConfigId = 0;
        message.scSubscriberId = 0n;
        message.customerUserId = 0;
        message.customerName = "";
        message.enabled = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 subscriber_config_id */ 1:
                    message.subscriberConfigId = reader.int32();
                    break;
                case /* int64 sc_subscriber_id */ 2:
                    message.scSubscriberId = reader.int64().toBigInt();
                    break;
                case /* int32 customer_user_id */ 3:
                    message.customerUserId = reader.int32();
                    break;
                case /* string customer_name */ 4:
                    message.customerName = reader.string();
                    break;
                case /* bool enabled */ 5:
                    message.enabled = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 subscriber_config_id = 1; */
        if (message.subscriberConfigId !== 0)
            writer.tag(1, WireType.Varint).int32(message.subscriberConfigId);
        /* int64 sc_subscriber_id = 2; */
        if (message.scSubscriberId !== 0n)
            writer.tag(2, WireType.Varint).int64(message.scSubscriberId);
        /* int32 customer_user_id = 3; */
        if (message.customerUserId !== 0)
            writer.tag(3, WireType.Varint).int32(message.customerUserId);
        /* string customer_name = 4; */
        if (message.customerName !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.customerName);
        /* bool enabled = 5; */
        if (message.enabled !== false)
            writer.tag(5, WireType.Varint).bool(message.enabled);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SCSubscriberSummary
 */
export const SCSubscriberSummary = new SCSubscriberSummary$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SCSubscriberSummaryList$Type extends MessageType {
    constructor() {
        super("SCSubscriberSummaryList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SCSubscriberSummary },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated SCSubscriberSummary results */ 1:
                    message.results.push(SCSubscriberSummary.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated SCSubscriberSummary results = 1; */
        for (let i = 0; i < message.results.length; i++)
            SCSubscriberSummary.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SCSubscriberSummaryList
 */
export const SCSubscriberSummaryList = new SCSubscriberSummaryList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SCTradeMapping$Type extends MessageType {
    constructor() {
        super("SCTradeMapping", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "subscriber_config_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "sc_trade_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "kalos_department_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "kalos_job_type_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "department_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "job_type_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.subscriberConfigId = 0;
        message.scTradeName = "";
        message.kalosDepartmentId = 0;
        message.kalosJobTypeId = 0;
        message.departmentName = "";
        message.jobTypeName = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 subscriber_config_id */ 2:
                    message.subscriberConfigId = reader.int32();
                    break;
                case /* string sc_trade_name */ 3:
                    message.scTradeName = reader.string();
                    break;
                case /* int32 kalos_department_id */ 4:
                    message.kalosDepartmentId = reader.int32();
                    break;
                case /* int32 kalos_job_type_id */ 5:
                    message.kalosJobTypeId = reader.int32();
                    break;
                case /* string department_name */ 6:
                    message.departmentName = reader.string();
                    break;
                case /* string job_type_name */ 7:
                    message.jobTypeName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 subscriber_config_id = 2; */
        if (message.subscriberConfigId !== 0)
            writer.tag(2, WireType.Varint).int32(message.subscriberConfigId);
        /* string sc_trade_name = 3; */
        if (message.scTradeName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.scTradeName);
        /* int32 kalos_department_id = 4; */
        if (message.kalosDepartmentId !== 0)
            writer.tag(4, WireType.Varint).int32(message.kalosDepartmentId);
        /* int32 kalos_job_type_id = 5; */
        if (message.kalosJobTypeId !== 0)
            writer.tag(5, WireType.Varint).int32(message.kalosJobTypeId);
        /* string department_name = 6; */
        if (message.departmentName !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.departmentName);
        /* string job_type_name = 7; */
        if (message.jobTypeName !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.jobTypeName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SCTradeMapping
 */
export const SCTradeMapping = new SCTradeMapping$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SCTradeMappingList$Type extends MessageType {
    constructor() {
        super("SCTradeMappingList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SCTradeMapping },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated SCTradeMapping results */ 1:
                    message.results.push(SCTradeMapping.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated SCTradeMapping results = 1; */
        for (let i = 0; i < message.results.length; i++)
            SCTradeMapping.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SCTradeMappingList
 */
export const SCTradeMappingList = new SCTradeMappingList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SCPriorityMapping$Type extends MessageType {
    constructor() {
        super("SCPriorityMapping", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "subscriber_config_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "sc_priority_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "kalos_priority", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "customer_priority_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "customer_priority_label", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.subscriberConfigId = 0;
        message.scPriorityName = "";
        message.kalosPriority = "";
        message.customerPriorityId = 0;
        message.customerPriorityLabel = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 subscriber_config_id */ 2:
                    message.subscriberConfigId = reader.int32();
                    break;
                case /* string sc_priority_name */ 3:
                    message.scPriorityName = reader.string();
                    break;
                case /* string kalos_priority */ 4:
                    message.kalosPriority = reader.string();
                    break;
                case /* int32 customer_priority_id */ 5:
                    message.customerPriorityId = reader.int32();
                    break;
                case /* string customer_priority_label */ 6:
                    message.customerPriorityLabel = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 subscriber_config_id = 2; */
        if (message.subscriberConfigId !== 0)
            writer.tag(2, WireType.Varint).int32(message.subscriberConfigId);
        /* string sc_priority_name = 3; */
        if (message.scPriorityName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.scPriorityName);
        /* string kalos_priority = 4; */
        if (message.kalosPriority !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.kalosPriority);
        /* int32 customer_priority_id = 5; */
        if (message.customerPriorityId !== 0)
            writer.tag(5, WireType.Varint).int32(message.customerPriorityId);
        /* string customer_priority_label = 6; */
        if (message.customerPriorityLabel !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.customerPriorityLabel);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SCPriorityMapping
 */
export const SCPriorityMapping = new SCPriorityMapping$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SCPriorityMappingList$Type extends MessageType {
    constructor() {
        super("SCPriorityMappingList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SCPriorityMapping },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated SCPriorityMapping results */ 1:
                    message.results.push(SCPriorityMapping.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated SCPriorityMapping results = 1; */
        for (let i = 0; i < message.results.length; i++)
            SCPriorityMapping.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SCPriorityMappingList
 */
export const SCPriorityMappingList = new SCPriorityMappingList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SCStatusMapping$Type extends MessageType {
    constructor() {
        super("SCStatusMapping", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "subscriber_config_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "sc_status_primary", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "sc_status_extended", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "kalos_status", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.subscriberConfigId = 0;
        message.scStatusPrimary = "";
        message.scStatusExtended = "";
        message.kalosStatus = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 subscriber_config_id */ 2:
                    message.subscriberConfigId = reader.int32();
                    break;
                case /* string sc_status_primary */ 3:
                    message.scStatusPrimary = reader.string();
                    break;
                case /* string sc_status_extended */ 4:
                    message.scStatusExtended = reader.string();
                    break;
                case /* string kalos_status */ 5:
                    message.kalosStatus = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 subscriber_config_id = 2; */
        if (message.subscriberConfigId !== 0)
            writer.tag(2, WireType.Varint).int32(message.subscriberConfigId);
        /* string sc_status_primary = 3; */
        if (message.scStatusPrimary !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.scStatusPrimary);
        /* string sc_status_extended = 4; */
        if (message.scStatusExtended !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.scStatusExtended);
        /* string kalos_status = 5; */
        if (message.kalosStatus !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.kalosStatus);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SCStatusMapping
 */
export const SCStatusMapping = new SCStatusMapping$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SCStatusMappingList$Type extends MessageType {
    constructor() {
        super("SCStatusMappingList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SCStatusMapping },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated SCStatusMapping results */ 1:
                    message.results.push(SCStatusMapping.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated SCStatusMapping results = 1; */
        for (let i = 0; i < message.results.length; i++)
            SCStatusMapping.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SCStatusMappingList
 */
export const SCStatusMappingList = new SCStatusMappingList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SCUnmappedTrade$Type extends MessageType {
    constructor() {
        super("SCUnmappedTrade", [
            { no: 1, name: "sc_trade_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "subscriber_config_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "waiting_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "latest_wo_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "latest_seen_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.scTradeName = "";
        message.subscriberConfigId = 0;
        message.waitingCount = 0;
        message.latestWoNumber = "";
        message.latestSeenAt = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string sc_trade_name */ 1:
                    message.scTradeName = reader.string();
                    break;
                case /* int32 subscriber_config_id */ 2:
                    message.subscriberConfigId = reader.int32();
                    break;
                case /* int32 waiting_count */ 3:
                    message.waitingCount = reader.int32();
                    break;
                case /* string latest_wo_number */ 4:
                    message.latestWoNumber = reader.string();
                    break;
                case /* string latest_seen_at */ 5:
                    message.latestSeenAt = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string sc_trade_name = 1; */
        if (message.scTradeName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.scTradeName);
        /* int32 subscriber_config_id = 2; */
        if (message.subscriberConfigId !== 0)
            writer.tag(2, WireType.Varint).int32(message.subscriberConfigId);
        /* int32 waiting_count = 3; */
        if (message.waitingCount !== 0)
            writer.tag(3, WireType.Varint).int32(message.waitingCount);
        /* string latest_wo_number = 4; */
        if (message.latestWoNumber !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.latestWoNumber);
        /* string latest_seen_at = 5; */
        if (message.latestSeenAt !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.latestSeenAt);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SCUnmappedTrade
 */
export const SCUnmappedTrade = new SCUnmappedTrade$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SCUnmappedTradeList$Type extends MessageType {
    constructor() {
        super("SCUnmappedTradeList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SCUnmappedTrade },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated SCUnmappedTrade results */ 1:
                    message.results.push(SCUnmappedTrade.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated SCUnmappedTrade results = 1; */
        for (let i = 0; i < message.results.length; i++)
            SCUnmappedTrade.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SCUnmappedTradeList
 */
export const SCUnmappedTradeList = new SCUnmappedTradeList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SCMappingRef$Type extends MessageType {
    constructor() {
        super("SCMappingRef", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SCMappingRef
 */
export const SCMappingRef = new SCMappingRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SCTechnicianMapping$Type extends MessageType {
    constructor() {
        super("SCTechnicianMapping", [
            { no: 1, name: "user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "sc_user_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "technician_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.userId = 0;
        message.scUserId = 0n;
        message.technicianName = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 user_id */ 1:
                    message.userId = reader.int32();
                    break;
                case /* int64 sc_user_id */ 2:
                    message.scUserId = reader.int64().toBigInt();
                    break;
                case /* string technician_name */ 3:
                    message.technicianName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 user_id = 1; */
        if (message.userId !== 0)
            writer.tag(1, WireType.Varint).int32(message.userId);
        /* int64 sc_user_id = 2; */
        if (message.scUserId !== 0n)
            writer.tag(2, WireType.Varint).int64(message.scUserId);
        /* string technician_name = 3; */
        if (message.technicianName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.technicianName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SCTechnicianMapping
 */
export const SCTechnicianMapping = new SCTechnicianMapping$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SCTechnicianMappingList$Type extends MessageType {
    constructor() {
        super("SCTechnicianMappingList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SCTechnicianMapping },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated SCTechnicianMapping results */ 1:
                    message.results.push(SCTechnicianMapping.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated SCTechnicianMapping results = 1; */
        for (let i = 0; i < message.results.length; i++)
            SCTechnicianMapping.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SCTechnicianMappingList
 */
export const SCTechnicianMappingList = new SCTechnicianMappingList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SCTechnicianRef$Type extends MessageType {
    constructor() {
        super("SCTechnicianRef", [
            { no: 1, name: "user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.userId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 user_id */ 1:
                    message.userId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 user_id = 1; */
        if (message.userId !== 0)
            writer.tag(1, WireType.Varint).int32(message.userId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SCTechnicianRef
 */
export const SCTechnicianRef = new SCTechnicianRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SCPhoneCheckIn$Type extends MessageType {
    constructor() {
        super("SCPhoneCheckIn", [
            { no: 1, name: "available", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "phone_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "pin", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "wo_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "reason_unavailable", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.available = false;
        message.phoneNumber = "";
        message.pin = "";
        message.woNumber = "";
        message.reasonUnavailable = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool available */ 1:
                    message.available = reader.bool();
                    break;
                case /* string phone_number */ 2:
                    message.phoneNumber = reader.string();
                    break;
                case /* string pin */ 3:
                    message.pin = reader.string();
                    break;
                case /* string wo_number */ 4:
                    message.woNumber = reader.string();
                    break;
                case /* string reason_unavailable */ 5:
                    message.reasonUnavailable = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool available = 1; */
        if (message.available !== false)
            writer.tag(1, WireType.Varint).bool(message.available);
        /* string phone_number = 2; */
        if (message.phoneNumber !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.phoneNumber);
        /* string pin = 3; */
        if (message.pin !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.pin);
        /* string wo_number = 4; */
        if (message.woNumber !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.woNumber);
        /* string reason_unavailable = 5; */
        if (message.reasonUnavailable !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.reasonUnavailable);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SCPhoneCheckIn
 */
export const SCPhoneCheckIn = new SCPhoneCheckIn$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SCCustomerRef$Type extends MessageType {
    constructor() {
        super("SCCustomerRef", [
            { no: 1, name: "customer_user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.customerUserId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 customer_user_id */ 1:
                    message.customerUserId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 customer_user_id = 1; */
        if (message.customerUserId !== 0)
            writer.tag(1, WireType.Varint).int32(message.customerUserId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SCCustomerRef
 */
export const SCCustomerRef = new SCCustomerRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SCStoreAutoAccept$Type extends MessageType {
    constructor() {
        super("SCStoreAutoAccept", [
            { no: 1, name: "location_map_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "sc_location_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "property_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "store_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "address", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "city", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "state", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "zip", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "auto_accept", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 10, name: "updated_by", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 11, name: "updated_by_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "updated_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.locationMapId = 0;
        message.scLocationId = 0n;
        message.propertyId = 0;
        message.storeId = "";
        message.address = "";
        message.city = "";
        message.state = "";
        message.zip = "";
        message.autoAccept = false;
        message.updatedBy = 0;
        message.updatedByName = "";
        message.updatedAt = "";
        message.enabled = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 location_map_id */ 1:
                    message.locationMapId = reader.int32();
                    break;
                case /* int64 sc_location_id */ 2:
                    message.scLocationId = reader.int64().toBigInt();
                    break;
                case /* int32 property_id */ 3:
                    message.propertyId = reader.int32();
                    break;
                case /* string store_id */ 4:
                    message.storeId = reader.string();
                    break;
                case /* string address */ 5:
                    message.address = reader.string();
                    break;
                case /* string city */ 6:
                    message.city = reader.string();
                    break;
                case /* string state */ 7:
                    message.state = reader.string();
                    break;
                case /* string zip */ 8:
                    message.zip = reader.string();
                    break;
                case /* bool auto_accept */ 9:
                    message.autoAccept = reader.bool();
                    break;
                case /* int32 updated_by */ 10:
                    message.updatedBy = reader.int32();
                    break;
                case /* string updated_by_name */ 11:
                    message.updatedByName = reader.string();
                    break;
                case /* string updated_at */ 12:
                    message.updatedAt = reader.string();
                    break;
                case /* bool enabled */ 13:
                    message.enabled = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 location_map_id = 1; */
        if (message.locationMapId !== 0)
            writer.tag(1, WireType.Varint).int32(message.locationMapId);
        /* int64 sc_location_id = 2; */
        if (message.scLocationId !== 0n)
            writer.tag(2, WireType.Varint).int64(message.scLocationId);
        /* int32 property_id = 3; */
        if (message.propertyId !== 0)
            writer.tag(3, WireType.Varint).int32(message.propertyId);
        /* string store_id = 4; */
        if (message.storeId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.storeId);
        /* string address = 5; */
        if (message.address !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.address);
        /* string city = 6; */
        if (message.city !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.city);
        /* string state = 7; */
        if (message.state !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.state);
        /* string zip = 8; */
        if (message.zip !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.zip);
        /* bool auto_accept = 9; */
        if (message.autoAccept !== false)
            writer.tag(9, WireType.Varint).bool(message.autoAccept);
        /* int32 updated_by = 10; */
        if (message.updatedBy !== 0)
            writer.tag(10, WireType.Varint).int32(message.updatedBy);
        /* string updated_by_name = 11; */
        if (message.updatedByName !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.updatedByName);
        /* string updated_at = 12; */
        if (message.updatedAt !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.updatedAt);
        /* bool enabled = 13; */
        if (message.enabled !== false)
            writer.tag(13, WireType.Varint).bool(message.enabled);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SCStoreAutoAccept
 */
export const SCStoreAutoAccept = new SCStoreAutoAccept$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SCCustomerSettings$Type extends MessageType {
    constructor() {
        super("SCCustomerSettings", [
            { no: 1, name: "configured", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "subscriber_config_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "can_edit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "stores", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SCStoreAutoAccept },
            { no: 6, name: "new_store_mode", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "new_store_mode_updated_by", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "new_store_mode_updated_by_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "new_store_mode_updated_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.configured = false;
        message.subscriberConfigId = 0;
        message.enabled = false;
        message.canEdit = false;
        message.stores = [];
        message.newStoreMode = "";
        message.newStoreModeUpdatedBy = 0;
        message.newStoreModeUpdatedByName = "";
        message.newStoreModeUpdatedAt = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool configured */ 1:
                    message.configured = reader.bool();
                    break;
                case /* int32 subscriber_config_id */ 2:
                    message.subscriberConfigId = reader.int32();
                    break;
                case /* bool enabled */ 3:
                    message.enabled = reader.bool();
                    break;
                case /* bool can_edit */ 4:
                    message.canEdit = reader.bool();
                    break;
                case /* repeated SCStoreAutoAccept stores */ 5:
                    message.stores.push(SCStoreAutoAccept.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string new_store_mode */ 6:
                    message.newStoreMode = reader.string();
                    break;
                case /* int32 new_store_mode_updated_by */ 7:
                    message.newStoreModeUpdatedBy = reader.int32();
                    break;
                case /* string new_store_mode_updated_by_name */ 8:
                    message.newStoreModeUpdatedByName = reader.string();
                    break;
                case /* string new_store_mode_updated_at */ 9:
                    message.newStoreModeUpdatedAt = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool configured = 1; */
        if (message.configured !== false)
            writer.tag(1, WireType.Varint).bool(message.configured);
        /* int32 subscriber_config_id = 2; */
        if (message.subscriberConfigId !== 0)
            writer.tag(2, WireType.Varint).int32(message.subscriberConfigId);
        /* bool enabled = 3; */
        if (message.enabled !== false)
            writer.tag(3, WireType.Varint).bool(message.enabled);
        /* bool can_edit = 4; */
        if (message.canEdit !== false)
            writer.tag(4, WireType.Varint).bool(message.canEdit);
        /* repeated SCStoreAutoAccept stores = 5; */
        for (let i = 0; i < message.stores.length; i++)
            SCStoreAutoAccept.internalBinaryWrite(message.stores[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* string new_store_mode = 6; */
        if (message.newStoreMode !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.newStoreMode);
        /* int32 new_store_mode_updated_by = 7; */
        if (message.newStoreModeUpdatedBy !== 0)
            writer.tag(7, WireType.Varint).int32(message.newStoreModeUpdatedBy);
        /* string new_store_mode_updated_by_name = 8; */
        if (message.newStoreModeUpdatedByName !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.newStoreModeUpdatedByName);
        /* string new_store_mode_updated_at = 9; */
        if (message.newStoreModeUpdatedAt !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.newStoreModeUpdatedAt);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SCCustomerSettings
 */
export const SCCustomerSettings = new SCCustomerSettings$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SCSetCustomerEnabledRequest$Type extends MessageType {
    constructor() {
        super("SCSetCustomerEnabledRequest", [
            { no: 1, name: "customer_user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.customerUserId = 0;
        message.enabled = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 customer_user_id */ 1:
                    message.customerUserId = reader.int32();
                    break;
                case /* bool enabled */ 2:
                    message.enabled = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 customer_user_id = 1; */
        if (message.customerUserId !== 0)
            writer.tag(1, WireType.Varint).int32(message.customerUserId);
        /* bool enabled = 2; */
        if (message.enabled !== false)
            writer.tag(2, WireType.Varint).bool(message.enabled);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SCSetCustomerEnabledRequest
 */
export const SCSetCustomerEnabledRequest = new SCSetCustomerEnabledRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SCStoreAutoAcceptChange$Type extends MessageType {
    constructor() {
        super("SCStoreAutoAcceptChange", [
            { no: 1, name: "location_map_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "auto_accept", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "enabled", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.locationMapId = 0;
        message.autoAccept = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 location_map_id */ 1:
                    message.locationMapId = reader.int32();
                    break;
                case /* bool auto_accept */ 2:
                    message.autoAccept = reader.bool();
                    break;
                case /* optional bool enabled */ 3:
                    message.enabled = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 location_map_id = 1; */
        if (message.locationMapId !== 0)
            writer.tag(1, WireType.Varint).int32(message.locationMapId);
        /* bool auto_accept = 2; */
        if (message.autoAccept !== false)
            writer.tag(2, WireType.Varint).bool(message.autoAccept);
        /* optional bool enabled = 3; */
        if (message.enabled !== undefined)
            writer.tag(3, WireType.Varint).bool(message.enabled);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SCStoreAutoAcceptChange
 */
export const SCStoreAutoAcceptChange = new SCStoreAutoAcceptChange$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SCSetStoreAutoAcceptRequest$Type extends MessageType {
    constructor() {
        super("SCSetStoreAutoAcceptRequest", [
            { no: 1, name: "customer_user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "changes", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SCStoreAutoAcceptChange },
            { no: 3, name: "new_store_mode", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.customerUserId = 0;
        message.changes = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 customer_user_id */ 1:
                    message.customerUserId = reader.int32();
                    break;
                case /* repeated SCStoreAutoAcceptChange changes */ 2:
                    message.changes.push(SCStoreAutoAcceptChange.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* optional string new_store_mode */ 3:
                    message.newStoreMode = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 customer_user_id = 1; */
        if (message.customerUserId !== 0)
            writer.tag(1, WireType.Varint).int32(message.customerUserId);
        /* repeated SCStoreAutoAcceptChange changes = 2; */
        for (let i = 0; i < message.changes.length; i++)
            SCStoreAutoAcceptChange.internalBinaryWrite(message.changes[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* optional string new_store_mode = 3; */
        if (message.newStoreMode !== undefined)
            writer.tag(3, WireType.LengthDelimited).string(message.newStoreMode);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SCSetStoreAutoAcceptRequest
 */
export const SCSetStoreAutoAcceptRequest = new SCSetStoreAutoAcceptRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SCInboundWorkOrder$Type extends MessageType {
    constructor() {
        super("SCInboundWorkOrder", [
            { no: 1, name: "sc_wo_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "wo_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "store_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "customer_user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "customer_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "property_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "address", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "city", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "state", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "trade", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "priority", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "nte", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 13, name: "nte_known", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 14, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "raised_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 16, name: "sla_due", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 17, name: "status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 18, name: "decided_via", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 19, name: "decided_by", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 20, name: "decided_by_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 21, name: "decided_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 22, name: "decline_reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 23, name: "event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 24, name: "created_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.scWoId = 0n;
        message.woNumber = "";
        message.storeId = "";
        message.customerUserId = 0;
        message.customerName = "";
        message.propertyId = 0;
        message.address = "";
        message.city = "";
        message.state = "";
        message.trade = "";
        message.priority = "";
        message.nte = 0;
        message.nteKnown = false;
        message.description = "";
        message.raisedBy = "";
        message.slaDue = "";
        message.status = "";
        message.decidedVia = "";
        message.decidedBy = 0;
        message.decidedByName = "";
        message.decidedAt = "";
        message.declineReason = "";
        message.eventId = 0;
        message.createdAt = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 sc_wo_id */ 1:
                    message.scWoId = reader.int64().toBigInt();
                    break;
                case /* string wo_number */ 2:
                    message.woNumber = reader.string();
                    break;
                case /* string store_id */ 3:
                    message.storeId = reader.string();
                    break;
                case /* int32 customer_user_id */ 4:
                    message.customerUserId = reader.int32();
                    break;
                case /* string customer_name */ 5:
                    message.customerName = reader.string();
                    break;
                case /* int32 property_id */ 6:
                    message.propertyId = reader.int32();
                    break;
                case /* string address */ 7:
                    message.address = reader.string();
                    break;
                case /* string city */ 8:
                    message.city = reader.string();
                    break;
                case /* string state */ 9:
                    message.state = reader.string();
                    break;
                case /* string trade */ 10:
                    message.trade = reader.string();
                    break;
                case /* string priority */ 11:
                    message.priority = reader.string();
                    break;
                case /* double nte */ 12:
                    message.nte = reader.double();
                    break;
                case /* bool nte_known */ 13:
                    message.nteKnown = reader.bool();
                    break;
                case /* string description */ 14:
                    message.description = reader.string();
                    break;
                case /* string raised_by */ 15:
                    message.raisedBy = reader.string();
                    break;
                case /* string sla_due */ 16:
                    message.slaDue = reader.string();
                    break;
                case /* string status */ 17:
                    message.status = reader.string();
                    break;
                case /* string decided_via */ 18:
                    message.decidedVia = reader.string();
                    break;
                case /* int32 decided_by */ 19:
                    message.decidedBy = reader.int32();
                    break;
                case /* string decided_by_name */ 20:
                    message.decidedByName = reader.string();
                    break;
                case /* string decided_at */ 21:
                    message.decidedAt = reader.string();
                    break;
                case /* string decline_reason */ 22:
                    message.declineReason = reader.string();
                    break;
                case /* int32 event_id */ 23:
                    message.eventId = reader.int32();
                    break;
                case /* string created_at */ 24:
                    message.createdAt = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 sc_wo_id = 1; */
        if (message.scWoId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.scWoId);
        /* string wo_number = 2; */
        if (message.woNumber !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.woNumber);
        /* string store_id = 3; */
        if (message.storeId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.storeId);
        /* int32 customer_user_id = 4; */
        if (message.customerUserId !== 0)
            writer.tag(4, WireType.Varint).int32(message.customerUserId);
        /* string customer_name = 5; */
        if (message.customerName !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.customerName);
        /* int32 property_id = 6; */
        if (message.propertyId !== 0)
            writer.tag(6, WireType.Varint).int32(message.propertyId);
        /* string address = 7; */
        if (message.address !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.address);
        /* string city = 8; */
        if (message.city !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.city);
        /* string state = 9; */
        if (message.state !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.state);
        /* string trade = 10; */
        if (message.trade !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.trade);
        /* string priority = 11; */
        if (message.priority !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.priority);
        /* double nte = 12; */
        if (message.nte !== 0)
            writer.tag(12, WireType.Bit64).double(message.nte);
        /* bool nte_known = 13; */
        if (message.nteKnown !== false)
            writer.tag(13, WireType.Varint).bool(message.nteKnown);
        /* string description = 14; */
        if (message.description !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.description);
        /* string raised_by = 15; */
        if (message.raisedBy !== "")
            writer.tag(15, WireType.LengthDelimited).string(message.raisedBy);
        /* string sla_due = 16; */
        if (message.slaDue !== "")
            writer.tag(16, WireType.LengthDelimited).string(message.slaDue);
        /* string status = 17; */
        if (message.status !== "")
            writer.tag(17, WireType.LengthDelimited).string(message.status);
        /* string decided_via = 18; */
        if (message.decidedVia !== "")
            writer.tag(18, WireType.LengthDelimited).string(message.decidedVia);
        /* int32 decided_by = 19; */
        if (message.decidedBy !== 0)
            writer.tag(19, WireType.Varint).int32(message.decidedBy);
        /* string decided_by_name = 20; */
        if (message.decidedByName !== "")
            writer.tag(20, WireType.LengthDelimited).string(message.decidedByName);
        /* string decided_at = 21; */
        if (message.decidedAt !== "")
            writer.tag(21, WireType.LengthDelimited).string(message.decidedAt);
        /* string decline_reason = 22; */
        if (message.declineReason !== "")
            writer.tag(22, WireType.LengthDelimited).string(message.declineReason);
        /* int32 event_id = 23; */
        if (message.eventId !== 0)
            writer.tag(23, WireType.Varint).int32(message.eventId);
        /* string created_at = 24; */
        if (message.createdAt !== "")
            writer.tag(24, WireType.LengthDelimited).string(message.createdAt);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SCInboundWorkOrder
 */
export const SCInboundWorkOrder = new SCInboundWorkOrder$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SCInboundWorkOrderList$Type extends MessageType {
    constructor() {
        super("SCInboundWorkOrderList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SCInboundWorkOrder },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated SCInboundWorkOrder results */ 1:
                    message.results.push(SCInboundWorkOrder.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated SCInboundWorkOrder results = 1; */
        for (let i = 0; i < message.results.length; i++)
            SCInboundWorkOrder.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SCInboundWorkOrderList
 */
export const SCInboundWorkOrderList = new SCInboundWorkOrderList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SCInboundRef$Type extends MessageType {
    constructor() {
        super("SCInboundRef", [
            { no: 1, name: "sc_wo_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.scWoId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 sc_wo_id */ 1:
                    message.scWoId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 sc_wo_id = 1; */
        if (message.scWoId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.scWoId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SCInboundRef
 */
export const SCInboundRef = new SCInboundRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SCDeclineInboundRequest$Type extends MessageType {
    constructor() {
        super("SCDeclineInboundRequest", [
            { no: 1, name: "sc_wo_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.scWoId = 0n;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 sc_wo_id */ 1:
                    message.scWoId = reader.int64().toBigInt();
                    break;
                case /* string reason */ 2:
                    message.reason = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 sc_wo_id = 1; */
        if (message.scWoId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.scWoId);
        /* string reason = 2; */
        if (message.reason !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.reason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SCDeclineInboundRequest
 */
export const SCDeclineInboundRequest = new SCDeclineInboundRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SCTechnicianCertification$Type extends MessageType {
    constructor() {
        super("SCTechnicianCertification", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "technician_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "certification_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "trade", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "level", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "certification_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "expiration_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "image_file_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "image_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "sc_certification_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 12, name: "sc_auth_user_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 13, name: "sync_status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "sync_error", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "created_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.userId = 0;
        message.technicianName = "";
        message.certificationNumber = "";
        message.trade = 0;
        message.level = 0;
        message.certificationDate = "";
        message.expirationDate = "";
        message.imageFileId = 0;
        message.imageUrl = "";
        message.scCertificationId = 0n;
        message.scAuthUserId = 0n;
        message.syncStatus = "";
        message.syncError = "";
        message.createdAt = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 user_id */ 2:
                    message.userId = reader.int32();
                    break;
                case /* string technician_name */ 3:
                    message.technicianName = reader.string();
                    break;
                case /* string certification_number */ 4:
                    message.certificationNumber = reader.string();
                    break;
                case /* int32 trade */ 5:
                    message.trade = reader.int32();
                    break;
                case /* int32 level */ 6:
                    message.level = reader.int32();
                    break;
                case /* string certification_date */ 7:
                    message.certificationDate = reader.string();
                    break;
                case /* string expiration_date */ 8:
                    message.expirationDate = reader.string();
                    break;
                case /* int32 image_file_id */ 9:
                    message.imageFileId = reader.int32();
                    break;
                case /* string image_url */ 10:
                    message.imageUrl = reader.string();
                    break;
                case /* int64 sc_certification_id */ 11:
                    message.scCertificationId = reader.int64().toBigInt();
                    break;
                case /* int64 sc_auth_user_id */ 12:
                    message.scAuthUserId = reader.int64().toBigInt();
                    break;
                case /* string sync_status */ 13:
                    message.syncStatus = reader.string();
                    break;
                case /* string sync_error */ 14:
                    message.syncError = reader.string();
                    break;
                case /* string created_at */ 15:
                    message.createdAt = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 user_id = 2; */
        if (message.userId !== 0)
            writer.tag(2, WireType.Varint).int32(message.userId);
        /* string technician_name = 3; */
        if (message.technicianName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.technicianName);
        /* string certification_number = 4; */
        if (message.certificationNumber !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.certificationNumber);
        /* int32 trade = 5; */
        if (message.trade !== 0)
            writer.tag(5, WireType.Varint).int32(message.trade);
        /* int32 level = 6; */
        if (message.level !== 0)
            writer.tag(6, WireType.Varint).int32(message.level);
        /* string certification_date = 7; */
        if (message.certificationDate !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.certificationDate);
        /* string expiration_date = 8; */
        if (message.expirationDate !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.expirationDate);
        /* int32 image_file_id = 9; */
        if (message.imageFileId !== 0)
            writer.tag(9, WireType.Varint).int32(message.imageFileId);
        /* string image_url = 10; */
        if (message.imageUrl !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.imageUrl);
        /* int64 sc_certification_id = 11; */
        if (message.scCertificationId !== 0n)
            writer.tag(11, WireType.Varint).int64(message.scCertificationId);
        /* int64 sc_auth_user_id = 12; */
        if (message.scAuthUserId !== 0n)
            writer.tag(12, WireType.Varint).int64(message.scAuthUserId);
        /* string sync_status = 13; */
        if (message.syncStatus !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.syncStatus);
        /* string sync_error = 14; */
        if (message.syncError !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.syncError);
        /* string created_at = 15; */
        if (message.createdAt !== "")
            writer.tag(15, WireType.LengthDelimited).string(message.createdAt);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SCTechnicianCertification
 */
export const SCTechnicianCertification = new SCTechnicianCertification$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SCTechnicianCertificationList$Type extends MessageType {
    constructor() {
        super("SCTechnicianCertificationList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SCTechnicianCertification },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated SCTechnicianCertification results */ 1:
                    message.results.push(SCTechnicianCertification.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated SCTechnicianCertification results = 1; */
        for (let i = 0; i < message.results.length; i++)
            SCTechnicianCertification.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SCTechnicianCertificationList
 */
export const SCTechnicianCertificationList = new SCTechnicianCertificationList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SCCertificationStatus$Type extends MessageType {
    constructor() {
        super("SCCertificationStatus", [
            { no: 1, name: "user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "on_file", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "source", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "certification", kind: "message", T: () => SCTechnicianCertification },
            { no: 5, name: "sc_user_mapped", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "servicechannel_configured", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "detail", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.userId = 0;
        message.onFile = false;
        message.source = "";
        message.scUserMapped = false;
        message.servicechannelConfigured = false;
        message.detail = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 user_id */ 1:
                    message.userId = reader.int32();
                    break;
                case /* bool on_file */ 2:
                    message.onFile = reader.bool();
                    break;
                case /* string source */ 3:
                    message.source = reader.string();
                    break;
                case /* SCTechnicianCertification certification */ 4:
                    message.certification = SCTechnicianCertification.internalBinaryRead(reader, reader.uint32(), options, message.certification);
                    break;
                case /* bool sc_user_mapped */ 5:
                    message.scUserMapped = reader.bool();
                    break;
                case /* bool servicechannel_configured */ 6:
                    message.servicechannelConfigured = reader.bool();
                    break;
                case /* string detail */ 7:
                    message.detail = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 user_id = 1; */
        if (message.userId !== 0)
            writer.tag(1, WireType.Varint).int32(message.userId);
        /* bool on_file = 2; */
        if (message.onFile !== false)
            writer.tag(2, WireType.Varint).bool(message.onFile);
        /* string source = 3; */
        if (message.source !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.source);
        /* SCTechnicianCertification certification = 4; */
        if (message.certification)
            SCTechnicianCertification.internalBinaryWrite(message.certification, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* bool sc_user_mapped = 5; */
        if (message.scUserMapped !== false)
            writer.tag(5, WireType.Varint).bool(message.scUserMapped);
        /* bool servicechannel_configured = 6; */
        if (message.servicechannelConfigured !== false)
            writer.tag(6, WireType.Varint).bool(message.servicechannelConfigured);
        /* string detail = 7; */
        if (message.detail !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.detail);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SCCertificationStatus
 */
export const SCCertificationStatus = new SCCertificationStatus$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SCCreateCertificationRequest$Type extends MessageType {
    constructor() {
        super("SCCreateCertificationRequest", [
            { no: 1, name: "user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "certification_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "trade", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "level", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "certification_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "expiration_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "image", kind: "scalar", T: 12 /*ScalarType.BYTES*/ },
            { no: 8, name: "image_mime_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "image_file_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.userId = 0;
        message.certificationNumber = "";
        message.trade = 0;
        message.level = 0;
        message.certificationDate = "";
        message.expirationDate = "";
        message.image = new Uint8Array(0);
        message.imageMimeType = "";
        message.imageFileName = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 user_id */ 1:
                    message.userId = reader.int32();
                    break;
                case /* string certification_number */ 2:
                    message.certificationNumber = reader.string();
                    break;
                case /* int32 trade */ 3:
                    message.trade = reader.int32();
                    break;
                case /* int32 level */ 4:
                    message.level = reader.int32();
                    break;
                case /* string certification_date */ 5:
                    message.certificationDate = reader.string();
                    break;
                case /* string expiration_date */ 6:
                    message.expirationDate = reader.string();
                    break;
                case /* bytes image */ 7:
                    message.image = reader.bytes();
                    break;
                case /* string image_mime_type */ 8:
                    message.imageMimeType = reader.string();
                    break;
                case /* string image_file_name */ 9:
                    message.imageFileName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 user_id = 1; */
        if (message.userId !== 0)
            writer.tag(1, WireType.Varint).int32(message.userId);
        /* string certification_number = 2; */
        if (message.certificationNumber !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.certificationNumber);
        /* int32 trade = 3; */
        if (message.trade !== 0)
            writer.tag(3, WireType.Varint).int32(message.trade);
        /* int32 level = 4; */
        if (message.level !== 0)
            writer.tag(4, WireType.Varint).int32(message.level);
        /* string certification_date = 5; */
        if (message.certificationDate !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.certificationDate);
        /* string expiration_date = 6; */
        if (message.expirationDate !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.expirationDate);
        /* bytes image = 7; */
        if (message.image.length)
            writer.tag(7, WireType.LengthDelimited).bytes(message.image);
        /* string image_mime_type = 8; */
        if (message.imageMimeType !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.imageMimeType);
        /* string image_file_name = 9; */
        if (message.imageFileName !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.imageFileName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SCCreateCertificationRequest
 */
export const SCCreateCertificationRequest = new SCCreateCertificationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SCCertificationCardImage$Type extends MessageType {
    constructor() {
        super("SCCertificationCardImage", [
            { no: 1, name: "image", kind: "scalar", T: 12 /*ScalarType.BYTES*/ },
            { no: 2, name: "image_mime_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.image = new Uint8Array(0);
        message.imageMimeType = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bytes image */ 1:
                    message.image = reader.bytes();
                    break;
                case /* string image_mime_type */ 2:
                    message.imageMimeType = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bytes image = 1; */
        if (message.image.length)
            writer.tag(1, WireType.LengthDelimited).bytes(message.image);
        /* string image_mime_type = 2; */
        if (message.imageMimeType !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.imageMimeType);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SCCertificationCardImage
 */
export const SCCertificationCardImage = new SCCertificationCardImage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SCCertificationCardFields$Type extends MessageType {
    constructor() {
        super("SCCertificationCardFields", [
            { no: 1, name: "certification_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "level", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "certification_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "expiration_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "holder_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "readable", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.certificationNumber = "";
        message.level = 0;
        message.certificationDate = "";
        message.expirationDate = "";
        message.holderName = "";
        message.readable = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string certification_number */ 1:
                    message.certificationNumber = reader.string();
                    break;
                case /* int32 level */ 2:
                    message.level = reader.int32();
                    break;
                case /* string certification_date */ 3:
                    message.certificationDate = reader.string();
                    break;
                case /* string expiration_date */ 4:
                    message.expirationDate = reader.string();
                    break;
                case /* string holder_name */ 5:
                    message.holderName = reader.string();
                    break;
                case /* bool readable */ 6:
                    message.readable = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string certification_number = 1; */
        if (message.certificationNumber !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.certificationNumber);
        /* int32 level = 2; */
        if (message.level !== 0)
            writer.tag(2, WireType.Varint).int32(message.level);
        /* string certification_date = 3; */
        if (message.certificationDate !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.certificationDate);
        /* string expiration_date = 4; */
        if (message.expirationDate !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.expirationDate);
        /* string holder_name = 5; */
        if (message.holderName !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.holderName);
        /* bool readable = 6; */
        if (message.readable !== false)
            writer.tag(6, WireType.Varint).bool(message.readable);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SCCertificationCardFields
 */
export const SCCertificationCardFields = new SCCertificationCardFields$Type();
/**
 * @generated ServiceType for protobuf service ServiceChannelService
 */
export const ServiceChannelService = new ServiceType("ServiceChannelService", [
    { name: "GetAuthURL", options: {}, I: SCGetAuthURLRequest, O: SCGetAuthURLResponse },
    { name: "ExchangeCode", options: {}, I: SCExchangeCodeRequest, O: Bool },
    { name: "RefreshToken", options: {}, I: SCRefreshTokenRequest, O: Bool },
    { name: "GetChecklist", options: {}, I: SCChecklistRequest, O: SCChecklistResponse },
    { name: "SaveChecklistAnswers", options: {}, I: SCSaveChecklistAnswersRequest, O: Bool },
    { name: "GetJobLink", options: {}, I: SCLinkRequest, O: SCLinkResponse },
    { name: "GetBadge", options: {}, I: SCBadgeRequest, O: SCBadgeResponse },
    { name: "SubmitProposal", options: {}, I: SCSubmitProposalRequest, O: Bool },
    { name: "RetrySyncEvent", options: {}, I: SCRetrySyncEventRequest, O: Bool },
    { name: "SendVisitCheckIn", options: {}, I: SCVisitRequest, O: SCVisitOutcome },
    { name: "SendVisitCheckOut", options: {}, I: SCVisitRequest, O: SCVisitOutcome },
    { name: "GetPhoneCheckIn", options: {}, I: SCLinkRequest, O: SCPhoneCheckIn },
    { name: "ReportPhoneCheckIn", options: {}, I: SCLinkRequest, O: Bool },
    { name: "ReportPhoneCheckOut", options: {}, I: SCLinkRequest, O: Bool },
    { name: "ListSCSubscribers", options: {}, I: Empty, O: SCSubscriberSummaryList },
    { name: "ListSCUnmappedTrades", options: {}, I: Empty, O: SCUnmappedTradeList },
    { name: "BatchGetSCTradeMapping", options: {}, I: SCTradeMapping, O: SCTradeMappingList },
    { name: "CreateSCTradeMapping", options: {}, I: SCTradeMapping, O: SCTradeMapping },
    { name: "UpdateSCTradeMapping", options: {}, I: SCTradeMapping, O: SCTradeMapping },
    { name: "DeleteSCTradeMapping", options: {}, I: SCMappingRef, O: Empty },
    { name: "BatchGetSCPriorityMapping", options: {}, I: SCPriorityMapping, O: SCPriorityMappingList },
    { name: "CreateSCPriorityMapping", options: {}, I: SCPriorityMapping, O: SCPriorityMapping },
    { name: "UpdateSCPriorityMapping", options: {}, I: SCPriorityMapping, O: SCPriorityMapping },
    { name: "DeleteSCPriorityMapping", options: {}, I: SCMappingRef, O: Empty },
    { name: "BatchGetSCStatusMapping", options: {}, I: SCStatusMapping, O: SCStatusMappingList },
    { name: "CreateSCStatusMapping", options: {}, I: SCStatusMapping, O: SCStatusMapping },
    { name: "UpdateSCStatusMapping", options: {}, I: SCStatusMapping, O: SCStatusMapping },
    { name: "DeleteSCStatusMapping", options: {}, I: SCMappingRef, O: Empty },
    { name: "BatchGetSCTechnicianMapping", options: {}, I: Empty, O: SCTechnicianMappingList },
    { name: "UpsertSCTechnicianMapping", options: {}, I: SCTechnicianMapping, O: SCTechnicianMapping },
    { name: "DeleteSCTechnicianMapping", options: {}, I: SCTechnicianRef, O: Empty },
    { name: "GetSCTechnicianCertification", options: {}, I: SCTechnicianRef, O: SCCertificationStatus },
    { name: "ListSCCertifiedTechnicians", options: {}, I: Empty, O: SCTechnicianCertificationList },
    { name: "CreateSCTechnicianCertification", options: {}, I: SCCreateCertificationRequest, O: SCCertificationStatus },
    { name: "ParseSCCertificationCard", options: {}, I: SCCertificationCardImage, O: SCCertificationCardFields },
    { name: "GetSCCustomerSettings", options: {}, I: SCCustomerRef, O: SCCustomerSettings },
    { name: "SetSCCustomerEnabled", options: {}, I: SCSetCustomerEnabledRequest, O: SCCustomerSettings },
    { name: "SetSCStoreAutoAccept", options: {}, I: SCSetStoreAutoAcceptRequest, O: SCCustomerSettings },
    { name: "ListSCInboundWorkOrders", options: {}, I: Empty, O: SCInboundWorkOrderList },
    { name: "GetSCInboundWorkOrder", options: {}, I: SCInboundRef, O: SCInboundWorkOrder },
    { name: "AcceptSCInboundWorkOrder", options: {}, I: SCInboundRef, O: SCInboundWorkOrder },
    { name: "DeclineSCInboundWorkOrder", options: {}, I: SCDeclineInboundRequest, O: SCInboundWorkOrder }
]);
